// extracted by mini-css-extract-plugin
export var actions = "_2z-0";
export var actionsContainer = "_2z-7";
export var border = "_2z-1";
export var childFullHeight = "_2z-f";
export var collapse = "_2z-2";
export var content = "_2z-a";
export var contentChild = "_2z-e";
export var fullscreen = "_2z-c";
export var hasLeftRadius = "_2z-k";
export var headerContainer = "_2z-3";
export var headerRow = "_2z-5";
export var hidePadding = "_2z-b";
export var navCollapsedGap = "_2z-l";
export var noScrollX = "_2z-m";
export var noScrollY = "_2z-n";
export var noTopPadding = "_2z-i";
export var optOutTopPadding = "_2z-d";
export var pageMain = "_2z-j";
export var pageOuter = "_2z-g";
export var pagePadding = "_2z-8";
export var pageScroll = "_2z-9";
export var profile = "_2z-o";
export var profileContainer = "_2z-p";
export var profileImage = "_2z-q";
export var profileMain = "_2z-r";
export var profileSubtitle = "_2z-t";
export var profileTitle = "_2z-s";
export var showLeftPadding = "_2z-h";
export var tabsPortalSlot = "_2z-6";
export var tabsWrapper = "_2z-4";
export var title = "_2z-u";